import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { retry } from "rxjs/operators";
import { HttpService } from "app/misc/http.service";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  constructor(
    private http: HttpClient,
    private httpService: HttpService,
  ) { }

  fetchPermissions = () =>
    this.http.get(`${environment.SERVER_URL}/roles/permissions`).pipe(retry(2));
  // getAuthUserInfo = () => {
  //   return this.httpService.getDataWithHeaders(
  //     environment.SERVER_URL + "/user/details"
  //   );
  // };
}
